import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BusinessContext } from "../../context/businessContext";
import { Box } from "@mui/material";
import TkMemo from "../../components/molecules/TkMemo";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { fakeTableList, headTitleList } from "./parts";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { GlobalContext } from "../../context/globalContext";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { IAPI_APP016_Request, IAPI_CON008_Response } from "../../type/apiType";
import { httpAPI_APP016, httpAPI_CON008 } from "./api/request";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkButton from "../../components/atoms/TkButton";
import {
  CommonOrCommonRetirementFlug,
  FormClassApply,
  formClassCorp,
} from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW050002 契約解除（加入者全員の合意）入力内容確認
 * @return SCRW050002
 */
const SCRW050002 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [stateTableList, setStateTableList] = useState<any>([]);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const [memoCheck, setMemoCheck] = useState(false);
  const [memoData, setMemoData] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [responseData, setResponseData] = useState<IAPI_CON008_Response>();
  const [status, setStatus] = useState<any>("");
  const [memoBodyList, setMemoBodyList] = useState<any[]>([]);
  const [symbolBodyList, setSymbolBodyList] = useState<any[]>([]);
  const [workFlow, setWorkFlow] = useState(false);
  const context = businessState?.job_04;
  const applyId = location.state?.applyId ?? context?.applyId;
  const httpReqIApplicationStatusUpdateRequest = useRef<IAPI_APP016_Request>({
    applyId: applyId,
    applyEvent: "",
  });
  const updataData = httpReqIApplicationStatusUpdateRequest.current;
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    // 退職手当共済契約解除参照API 呼び出し
    try {
      const res = await httpAPI_CON008({
        contractorNo: businessState.common?.contractorNo!,
        applyId: applyId,
      });
      setResponseData(res);
      setStatus(res.latestApplyStatus);

      let resArr = stateFakeTableList.current;

      if (res.resultCd === "I0000") {
        const bodyListData: any = [];
        setMemoBodyList(formatMemoData(res));
        res.statusList?.forEach((item: any) => {
          const data = [
            { id: "1" },
            { children: item.managerName },
            { children: item.process },
            { children: item.createDate },
            { children: item.processComment },
          ];
          bodyListData.push(data);
        });

        let file = res.formList?.find(
          (item) => item.formClass === "EXP0601016"
        );
        let showLine = isStatusAfterApproval(res.latestApplyStatus);
        const symbolBodyList = [
          [
            {
              children: file && (
                <TkDownloadLink
                  dataname={
                    TkGetCode(FormClassApply, "EXP0601016") +
                    "・" +
                    TkGetCode(FormClassApply, "EXP0601018")
                  }
                  base64filedata={file?.fileBase64!}
                  downloadBase64
                />
              ),
            },
            {
              children: showLine && res.symbolNo,
            },
            {
              children: showLine && res.decisionDate,
            },
          ],
        ];
        setSymbolBodyList(symbolBodyList);

        const contractorName = resArr.find(
          (item) => item.keyword === "contractorName"
        )!;
        const cancelDate = resArr.find(
          (item) => item.keyword === "cancelDate"
        )!;
        const maStaffNum = resArr.find(
          (item) => item.keyword === "maStaffNum"
        )!;
        const cancelReason = resArr.find(
          (item) => item.keyword === "cancelReason"
        )!;
        const downloadLink = resArr.find(
          (item) => item.keyword === "downloadLink"
        )!;
        const CertificateOfRecentThreeMonthsRetirees = resArr.find(
          (item) => item.keyword === "CertificateOfRecentThreeMonthsRetirees"
        )!;
        downloadLink.node = (
          <Box className="SCRW050002Link">
            {res.formList
              ?.filter(
                (item: any) =>
                  item.formClass === formClassCorp["契約解除同意書"]
              )
              .map((item: any, index: number) => (
                <Box key={index}>
                  <TkDownloadLink
                    dataname={item.fileName}
                    base64filedata={item.fileBase64}
                    downloadBase64={true}
                  ></TkDownloadLink>
                </Box>
              ))}
          </Box>
        );

        contractorName.text = `${businessState?.common?.contractorNo}:${businessState?.common?.contractorName}`;

        cancelDate.text = res.cancelDate;

        maStaffNum.text = `${res.maStaffNum}人`;

        cancelReason.text = res.cancelReason;
        const wfFlg =
          res.latestApplyStatus !== "00" && res.latestApplyStatus !== "16";
        setWorkFlow(wfFlg);

        CertificateOfRecentThreeMonthsRetirees.node = (
          <Box>
            <TkButton
              data-testid="tkDialogOkButtonForTest"
              onClick={() => handleEdit()}
            >
              確認
            </TkButton>
          </Box>
        );

        setStateTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  const formatMemoData = (data: any) => {
    return data.statusList.map((item: any, index: number) => {
      return [
        {
          children: item.managerName,
        },
        {
          children: item.process,
        },
        {
          children: item.createDate,
          align: "center",
        },
        {
          children: item.processComment,
        },
      ];
    });
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEdit = () => {
    setBusinessState({
      ...businessState,
      job_04: {
        applyId: applyId,
      },
    });
    navigate("/SCRC050115", { state: { applyId: applyId } });
  };

  //申請状況更新API実行
  const makeHttpObj = (data: IAPI_APP016_Request, num: any, formData?: any) => {
    data.applyEvent = num;
    data.reason = memoData;
    data.applyId = responseData?.applyId!;
    data.contractorNo = businessState.common?.contractorNo;
    if (memoCheck) {
      data.inquiryCode = "1";
    }
    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }
    return data;
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : btnName === "郵送"
        ? "11"
        : btnName === "承認"
        ? "3"
        : btnName === "取下げ"
        ? "13"
        : null;

    if (num === "3") {
      setIsOpen(true);
      return;
    }
    if (num === null) {
      return;
    }
    let reqData: IAPI_APP016_Request = makeHttpObj(updataData, num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      }
      setState({
        ...state,
        errorMsgId: res.resultCd,
      });
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(updataData, "3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const setOpen = () => {
    setIsOpen(false);
  };

  return (
    <Box className="SCRW050002" data-testid="SCRW050002PageForTest">
      {workFlow && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-04"
          applicationStatus={status}
        />
      )}

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW050002_01}</TkInfoManual>

      <TkFakeTable list={stateTableList} ruleSchema={[]} showButton={false} />

      <TkMemo onChange={onChange} showTable={true} bodyList={memoBodyList} />

      <TkTableWithNoLine headList={headTitleList} bodyList={symbolBodyList} />

      <Box className="buttonGroup">
        <TkBackButton mr />
        {workFlow ? (
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status}
            onClick={btnEvent}
          />
        ) : (
          <TkButton onClick={() => btnEvent("取下げ")}>取下げ</TkButton>
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW050002PageForDialog"
        open={isOpen}
        onSuccess={handleSave}
        onClose={setOpen}
      />
    </Box>
  );
};

export default SCRW050002;
